import { render, staticRenderFns } from "./crm-update_room.vue?vue&type=template&id=bfaf25b0&"
import script from "./crm-update_room.vue?vue&type=script&lang=js&"
export * from "./crm-update_room.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports